/* LittleMaddy: keeps the Shopify Forms sign-up teaser above the sticky add-to-cart bar. */
(function(){
  if(window.__lmFormsFix)return;window.__lmFormsFix=1;
  function off(){
    var s=document.querySelector('.lm-sticky');if(!s||!s.classList.contains('is-on'))return 0;
    var r=s.getBoundingClientRect(),vh=window.innerHeight;
    return (r.top<vh)?Math.ceil(vh-r.top)+8:0;
  }
  function fix(){
    var h=document.querySelector('shopify-forms-embed');if(!h||!h.shadowRoot)return;
    var o=off();
    h.shadowRoot.querySelectorAll('[class*="appEmbedRoot"]').forEach(function(e){
      var teaser=String(e.className).indexOf('Teaser')>-1;
      e.style.bottom=(teaser&&o)?o+'px':'';
      e.style.transition='bottom .2s ease';
    });
  }
  window.lmFormsFix=function(){setTimeout(fix,30);setTimeout(fix,320);};
  var t;function q(){clearTimeout(t);t=setTimeout(fix,40);}
  window.addEventListener('scroll',q,{passive:true});window.addEventListener('resize',q);
  var mo=new MutationObserver(q);
  function hook(){var h=document.querySelector('shopify-forms-embed');if(h&&h.shadowRoot){mo.observe(h.shadowRoot,{subtree:true,childList:true,attributes:true,attributeFilter:['class']});fix();return true;}return false;}
  function start(){if(!hook()){var n=0,iv=setInterval(function(){if(hook()||++n>60)clearInterval(iv);},500);}}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();